import { registry } from "@itemgo/core";
import { movePlugin } from "@itemgo/service-move";
import { deliveryPlugin } from "@itemgo/service-delivery";
import { manwithvanPlugin } from "@itemgo/service-manwithvan";
import { middlemilePlugin } from "@itemgo/service-middlemile";
import { rescuePlugin } from "@itemgo/service-rescue";
import { vehicleTransportPlugin } from "@itemgo/service-vehicletransport";

export function initPlugins() {
  registry.register(movePlugin);
  registry.register(deliveryPlugin);
  registry.register(manwithvanPlugin);
  registry.register(middlemilePlugin);
  registry.register(rescuePlugin);
  registry.register(vehicleTransportPlugin);
}
